<template>
  <icon-badge v-bind="props">
    <template #tooltip>
      {{ props.label }}
    </template>
  </icon-badge>
</template>

<script>
import IconBadge from '@/components/Common/IconBadge';
import { ReviewStage, AssessmentState } from '@/enums';

const STAGE_TO_NO_ASSESSMENTS_LABEL = {
  [ReviewStage.SCREENING]: 'No votes',
  [ReviewStage.FULL_TEXT_REVIEW]: 'No reviews',
  [ReviewStage.DATA_EXTRACTION]: 'No extractions',
};

const STAGE_TO_AWAITING_ONE_ASSESSMENT_LABEL = {
  [ReviewStage.SCREENING]: 'Awaiting one vote',
  [ReviewStage.FULL_TEXT_REVIEW]: 'Awaiting one review',
  [ReviewStage.DATA_EXTRACTION]: 'Awaiting one extraction',
};

const EXTRACTED_PROPS = {
  icon: 'check',
  label: 'Extracted',
  iconBgClass: 'success',
  iconColor: 'white',
  labelBgClass: 'extracted-label-bg',
  labelClass: 'white--text',
};

const EXCLUDED_PROPS = {
  icon: 'remove',
  label: 'Excluded',
  iconBgClass: 'error',
  labelBgClass: 'excluded-label-bg',
  labelClass: 'white--text',
  iconColor: 'white',
};

const STAGE_TO_COMPLETE_PROPS = {
  [ReviewStage.SCREENING]: EXCLUDED_PROPS,
  [ReviewStage.FULL_TEXT_REVIEW]: EXCLUDED_PROPS,
  [ReviewStage.DATA_EXTRACTION]: EXTRACTED_PROPS,
};

const STATUS_TO_PROPS = {
  [AssessmentState.PENDING]: {
    icon: 'inbox',
    label: (stage) => STAGE_TO_NO_ASSESSMENTS_LABEL[stage],
  },
  [AssessmentState.PARTIAL]: {
    icon: 'thumbs_up_down',
    label: (stage) => STAGE_TO_AWAITING_ONE_ASSESSMENT_LABEL[stage],
    iconBgClass: 'primary',
    iconColor: '#CDE0FF',
    labelBgClass: 'primary-light',
    labelClass: 'primary--text',
  },
  [AssessmentState.CONFLICTED]: {
    icon: 'error',
    label: 'Conflicted',
    iconBgClass: 'warning',
    iconColor: 'white',
    labelBgClass: 'conflicted-label-bg',
    labelClass: 'white--text',
  },
  [AssessmentState.COMPLETE]: (reviewStage) =>
    STAGE_TO_COMPLETE_PROPS[reviewStage],
};

export default {
  name: 'ReviewStageStatusBadge',
  components: { IconBadge },
  props: {
    stage: {
      type: String,
      required: true,
      validator: (value) =>
        Object.values(ReviewStage).includes(value),
    },
    status: {
      type: String,
      required: true,
      validator: (value) =>
        Object.keys(STATUS_TO_PROPS).includes(value),
    },
  },
  computed: {
    props() {
      let props = STATUS_TO_PROPS[this.status];
      if (typeof props === 'function') {
        props = props(this.stage);
      }
      return Object.keys(props).reduce((acc, key) => {
        const value = props[key];
        acc[key] =
          typeof value === 'function' ? value(this.stage) : value;
        return acc;
      }, {});
    },
  },
};
</script>

<style lang="scss">
.excluded-label-bg {
  background-color: #ff9292;
}
.conflicted-label-bg {
  background-color: #ffd873;
}
.extracted-label-bg {
  background-color: #5bd8b2;
}
</style>
